import {
  FeatureName,
  MediaPickerComponent,
  useIsFeatureEnabled,
  WorkspaceAsset,
} from '@gripp/shared-logic';
import { ReactNode } from 'react';
import { Platform, StyleProp, StyleSheet, View, ViewStyle } from 'react-native';
import { tokens } from '../crop-circle/tokens';
import { AssetDetails } from './assetDetails';
import { AssetHeaderImage } from './assetHeaderImage';

type AssetHeaderProps = {
  workspaceAsset: WorkspaceAsset;
  imgSize?: number;
  additionalHeaderBlock?: ReactNode;
  assetDetailsContainerStyle?: StyleProp<ViewStyle>;
  invalidateQuery?: () => void;
  mediaPicker?: MediaPickerComponent;
  onImagePress?: () => void;
};

export const AssetHeader = (props: AssetHeaderProps) => {
  const { workspaceAsset } = props;
  const isCropCircleRedesignEnabled = useIsFeatureEnabled(
    FeatureName.CropCircleRedesign
  );

  // TODO: Crop Circle Redesign | Remove after feature is fully rolled out
  if (!isCropCircleRedesignEnabled) {
    return (
      workspaceAsset && (
        <View style={styles.container}>
          <AssetHeaderImage
            assetCoverImage={workspaceAsset?.asset?.coverImage}
            imgSize={props.imgSize}
            invalidateQuery={props.invalidateQuery}
            workspaceAsset={workspaceAsset}
            mediaPicker={props.mediaPicker}
            onImagePress={props.onImagePress}
          />
          <View
            style={[
              styles.assetDetailsContainer,
              props.assetDetailsContainerStyle,
            ]}
          >
            <AssetDetails workspaceAsset={workspaceAsset} />
            {props.additionalHeaderBlock && props.additionalHeaderBlock}
          </View>
        </View>
      )
    );
  }

  return (
    workspaceAsset && (
      <View style={styles.containerCropCircle}>
        <AssetHeaderImage
          assetCoverImage={workspaceAsset?.asset?.coverImage}
          imgSize={props.imgSize}
          invalidateQuery={props.invalidateQuery}
          workspaceAsset={workspaceAsset}
          mediaPicker={props.mediaPicker}
          onImagePress={props.onImagePress}
        />
        <AssetDetails workspaceAsset={workspaceAsset} />
      </View>
    )
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    ...Platform.select({
      default: {
        marginTop: 10,
        marginBottom: 20,
        height: 56,
      },
      web: {
        flex: 1,
        margin: 0,
        height: '100%',
      },
    }),
  },
  assetDetailsContainer: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    flex: 1,
  },
  containerCropCircle: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    columnGap: tokens.spacing.md,
    height: 88,
    marginTop: tokens.spacing.sm,
    marginBottom: tokens.spacing.xl,
    width: '100%',
  },
});
